export default {
  updateAvailable: (state) => state.updateAvailable,
  currentHash: (state) => state.currentHash,
  latestHash: (state) => state.latestHash
}
